// extracted by mini-css-extract-plugin
export default {"contentHeader":"ClientDetail_contentHeader__b7dLQ"};